import axios from "axios";
import {
  AuthModel,
  Countries,
  UserModel,
  ReturnInformation,
  RegisterOrLoginResponse,
  GetAppNameByNameResponse,
  States,
  Cities,
} from "./_models";

const MAIN_API_URL = process.env.REACT_APP_MAINSERVICE_URL;
const IDENTITY_API_URL = process.env.REACT_APP_IDENTITYSERVICE_URL;
const CENTER_API_URL = process.env.REACT_APP_CENTERSERVICE_URL;
const SERVICE_API_URL = process.env.REACT_APP_SERVICE_URL;
export const GET_USER_BY_ACCESSTOKEN_URL = `${IDENTITY_API_URL}/api/v1/User/GetCurrentUserInformation`;
export const GET_ALL_COUNTRIES = `${MAIN_API_URL}/api/v1/Country/GetAllCountries`;
export const VERIFY_PHONENUMBER_URL = `${IDENTITY_API_URL}/api/v1/User/VerifyPhoneNumber`;
export const REGISTER_OR_LOGIN_URL = `${IDENTITY_API_URL}/api/v2/User/RegisterOrLogin`;
export const GET_APPNAME_BY_NAME_URL = `${MAIN_API_URL}/api/v1/AppName/GetAppNameByName`;
export const LOGOUT = `${IDENTITY_API_URL}/api/v1/User/Logout`;
export const GETCENTERWALLET = `${SERVICE_API_URL}/api/v1/Payment/GetProducerCenterWallet`;
export const GET_USER_PRODUCERCENTER = ` ${CENTER_API_URL}/api/v1/ProducerCenter/GetUserProducerCenter`;
export const ADD_USER_TO_PRODUCER_CENTER_BY_INVITATION = `${CENTER_API_URL}/api/v1/ProducerCenterEmployer/AddUserToProducerCenterByInvitation`;
export const GET_ALL_STATES = `${MAIN_API_URL}/api/v1/State/GetAllStates`;
export const GET_ALL_CITIES = `${MAIN_API_URL}/api/v1/City/GetAllCities`;
export const GENERATE_NEW_TOKEN = `${IDENTITY_API_URL}/api/v1/User/GenerateNewToken`;
export const GENERATE_NEW_TOKEN_V2 = `${IDENTITY_API_URL}/api/v2/User/GenerateNewToken`;

export function getAllCountries() {
  var data = axios
    .get<ReturnInformation<Countries>>(GET_ALL_COUNTRIES)
    .then((response) => {
      return response.data.data.countries;
    })
    .catch((error) => {
      return error;
    });
  return data;
}
export function GetAllCities() {
  var data = axios
    .get<ReturnInformation<Cities>>(GET_ALL_CITIES)
    .then((response) => {
      return response.data.data.cities;
    })
    .catch((error) => {
      return error;
    });
  return data;
}
export function GetAllStates() {
  var data = axios
    .get<ReturnInformation<States>>(GET_ALL_STATES)
    .then((response) => {
      return response.data.data.states;
    })
    .catch((error) => {
      return error;
    });
  return data;
}

export function GetAppNameByName(name: string, partAppName: string) {
  return axios
    .get<ReturnInformation<GetAppNameByNameResponse>>(
      `${GET_APPNAME_BY_NAME_URL}?Name=${name}&PartAppName=${partAppName}`
    )
    .catch((error) => {
      return error;
    });
}

export function verifyPhoneNumber(
  countryId: number,
  phoneNumber: string,
  countryCode: string
) {
  var bodyFormData = new FormData();
  bodyFormData.append("PhoneNumber", phoneNumber);
  bodyFormData.append("CountryCode", countryCode);
  bodyFormData.append("CountryId", countryId.toString());
  return axios.post(VERIFY_PHONENUMBER_URL, bodyFormData).catch((error) => {
    return error;
  });
}

export function RegisterOrLoginFunction(
  countryId: number,
  phoneNumber: string,
  countryCode: string,
  code: string,
  password: string,
  appNameId: string,
  deviceType,
  deviceOS,
  browserName,
  deviceName
) {
  var bodyFormData = new FormData();
  bodyFormData.append("PhoneNumber", phoneNumber);
  bodyFormData.append("CountryCode", countryCode);
  bodyFormData.append("CountryId", countryId.toString());
  bodyFormData.append("Code", code);
  bodyFormData.append("Password", password);
  bodyFormData.append("AppNameId", appNameId);
  bodyFormData.append("DeviceType", deviceType);
  bodyFormData.append("DeviceOS", deviceOS);
  bodyFormData.append("BrowserName", browserName);
  bodyFormData.append("DeviceName", deviceName);
  return axios
    .post<ReturnInformation<RegisterOrLoginResponse>>(
      REGISTER_OR_LOGIN_URL,
      bodyFormData
    )
    .catch((error) => {
      return error;
    });
}

export function getUserByToken(token: string) {
  return axios
    .get<ReturnInformation<UserModel>>(GET_USER_BY_ACCESSTOKEN_URL, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch((error) => {
      return error;
    });
}

export function LogoutRequest() {
  let data = axios.post(LOGOUT).catch((error) => {
    return error;
  });
  return data;
}

export function GetUserProducerCenterT(token: string) {
  return axios
    .get(GET_USER_PRODUCERCENTER, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch((error) => {
      return error;
    });
}

export function GetUserProducerCenterNT() {
  return axios
    .get<ReturnInformation<UserModel>>(GET_USER_PRODUCERCENTER)
    .catch((error) => {
      return error;
    });
}

export function GetProducerCenterWalletPriceT(
  producerCenterId: string,
  token: string
) {
  return axios
    .get<ReturnInformation<UserModel>>(
      `${GETCENTERWALLET}?ProducerCenterId=${producerCenterId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .catch((error) => {
      return error;
    });
}

export function GetProducerCenterWalletPriceNT(producerCenterId: string) {
  const url = `${GETCENTERWALLET}?ProducerCenterId=${producerCenterId}`;

  return axios.get(url).catch((error) => {
    return error;
  });
}

export function AddUserToProducerCenterByInvitation(Code: string) {
  var bodyFormData = new FormData();
  bodyFormData.append("Code", Code);

  let data = axios
    .post(ADD_USER_TO_PRODUCER_CENTER_BY_INVITATION, bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}

export function GetProducerCenterWalletPriceCustom(
  producerCenterId: string,
  token?: string // Make token optional
) {
  const url = `${GETCENTERWALLET}?ProducerCenterId=${producerCenterId}`;

  // Create headers object
  const headers: Record<string, string> = {};

  // Use if statement to add Authorization header if token is provided
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  // Make the API call with the conditionally set headers
  return axios
    .get(url, {
      headers,
    })
    .catch((error) => {
      return error;
    });
}
export function GetUserProducerCenterCustom(token?: string) {
  // Create headers object
  const headers: Record<string, string> = {};

  // Use if statement to add Authorization header if token is provided
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  // Make the API call with the conditionally set headers
  return axios.get(GET_USER_PRODUCERCENTER, {
    headers,
  });
}

export function GenerateNewToken(token?: string) {
  let data = axios
    .post(GENERATE_NEW_TOKEN,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    .catch((error) => {
      return error;
    });
  return data;
}

export function GenerateNewTokenV2(
  deviceType,
  deviceOS,
  browserName,
  deviceName,
) {

  var bodyFormData = new FormData();
  bodyFormData.append("DeviceType", deviceType);
  bodyFormData.append("DeviceOS", deviceOS);
  bodyFormData.append("BrowserName", browserName);
  bodyFormData.append("DeviceName", deviceName);

  let data = axios
    .post(GENERATE_NEW_TOKEN_V2,
      bodyFormData)
    .catch((error) => {
      return error;
    });
  return data;
}